// extracted by mini-css-extract-plugin
export var option = "_ax-0";
export var optionCard = "_ax-f";
export var optionContent = "_ax-g";
export var optionIcon = "_ax-i";
export var optionIconBox = "_ax-h";
export var optionLabel = "_ax-j";
export var optionPill = "_ax-m";
export var optionPillBadge = "_ax-p";
export var optionPillIcon = "_ax-n";
export var optionPillLabel = "_ax-o";
export var optionRadio = "_ax-k";
export var optionRadioInner = "_ax-l";
export var optionReveal = "_ax-2";
export var optionRevealDelay0 = "_ax-3";
export var optionRevealDelay1 = "_ax-4";
export var optionRevealDelay10 = "_ax-d";
export var optionRevealDelay11 = "_ax-e";
export var optionRevealDelay2 = "_ax-5";
export var optionRevealDelay3 = "_ax-6";
export var optionRevealDelay4 = "_ax-7";
export var optionRevealDelay5 = "_ax-8";
export var optionRevealDelay6 = "_ax-9";
export var optionRevealDelay7 = "_ax-a";
export var optionRevealDelay8 = "_ax-b";
export var optionRevealDelay9 = "_ax-c";
export var optionSelected = "_ax-1";